<button 
    [style.--color]="color"
    [style.--highlight]="highlight"
    >
    <ng-content></ng-content>
</button>